import axios, { GenericAbortSignal } from "axios";
import { JSONParsing } from "./helper";
// import {store} from '../Redux/store';

// const {dispatch, getState} = store;

export async function getHeaders() {
  let userData: any = localStorage.getItem("userdata");
  if (userData) {
    userData = JSON.parse(userData);

    return {
      authorization: `${userData?.access_token}`,
    };
  }
  return {};
}

type Methods = "head" | "options" | "put" | "post" | "patch" | "delete" | "get";

type ExtraOption = {
  headers?: any;
  signal?: GenericAbortSignal | undefined
};

export async function apiReq(
  endPoint = "",
  data = {},
  method: Methods,
  extraOption: ExtraOption = {
    headers: {},
    signal: undefined
  },
  requestOptions = {}
) {
  let headers = extraOption.headers;
  return new Promise(async (res, rej) => {
    const getTokenHeader = await getHeaders();
    headers = {
      ...getTokenHeader,
      ...headers,

    };

    if (method === "get" || method === "delete") {
      data = {
        ...requestOptions,
        ...data,
        headers,
      };
    }
    axios[method](endPoint, data, { headers, signal: extraOption.signal })
      .then((result: any) => {
        const { data } = result;

        if (data.status === false) {
          return rej(data);
        }

        return res(data);
      })
      .catch((error: any) => {
        // console.log(error);
        // console.log(error && error.response, 'the error respne');
        if (error && error.response && error.response.status === 403) {
        }
        if (error && error.response && error.response.data) {
          if (!error.response.data.message) {
            return rej({
              ...error.response.data,
              msg: error.response.data.message || "Network Error",
            });
          }
          return rej(error.response.data);
        } else {
          return rej({ message: "Network Error", msg: "Network Error" });
        }
      });
  });
}

export function apiPost(endPoint = "", data?: any, extraOption: ExtraOption = {}) {
  return apiReq(endPoint, data, "post", extraOption);
}

export function apiDelete(endPoint = "", data?: any, extraOption: ExtraOption = {}) {
  return apiReq(endPoint, data, "delete", extraOption);
}

export function apiPostFormData(endPoint = "", formData?: FormData, extraOption: ExtraOption = {}) {
  const headers = {
    ...extraOption.headers,
    'Content-Type': 'multipart/form-data',
  };
  return apiReq(endPoint, formData, "post", { ...extraOption, headers });
}


export function apiGet(
  endPoint = "",
  data?: any,
  extraOption: ExtraOption = {},
  requestOptions?: any
) {
  return apiReq(endPoint, data, "get", extraOption, requestOptions);
}

export function apiPut(endPoint = "", data?: any, extraOption: ExtraOption = {}) {
  return apiReq(endPoint, data, "put", extraOption);
}

export const setUserData = (data: any) => {
  localStorage.setItem("userdata", JSON.stringify(data));
};
export const clearlocalStorage = () => {
  localStorage.clear();
};

export const clearUserData = () => {
  localStorage.removeItem("userdata");
};

export const getUserData = () => {
  const data: any = localStorage.getItem("userdata");
  return JSONParsing(data);
};
